// 회원별 통계 행 리스트(이름 · 경기수 · 승무패 · 승률).

import type { PlayerRow } from "../../stats";

interface PlayerListProps {
  rows: PlayerRow[];
}

export function PlayerList({ rows }: PlayerListProps) {
  return (
    <div class="player-stat-list">
      {rows.map(r => {
        const decided = r.wins + r.losses;
        const ratePct = decided > 0 ? Math.round((r.wins / decided) * 100) : null;
        const draws = r.draws || 0;
        const recordStr = draws > 0
          ? `${r.wins}승 ${draws}무 ${r.losses}패`
          : `${r.wins}승 ${r.losses}패`;
        const meta = `${r.total}경기 · ${recordStr}${ratePct != null ? ` · ${ratePct}%` : ""}`;
        return (
          <div class="player-stat-row">
            <span class="player-stat-row__name">
              {r.name}
              {r.tag ? <span class="player-stat-row__tag">{r.tag}</span> : null}
            </span>
            <span class="player-stat-row__meta">{meta}</span>
          </div>
        );
      })}
    </div>
  );
}
